import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import {
	OverviewSponsoredCostsRow,
} from "components/BudgetBuilder/Overview/OverviewLineItemsList/OverviewSponsoredCostsRow";
import { getDefaultLineItems } from "store/actions/budgetBuilder";
import { convertByPeriodToByItem, convertToLookupTable } from "utils/budgetBuilder";
import { budgetBuilderSelectors, tenantSelectors } from "store/selectors";


export const OverviewSponsoredCosts = () => {
	const periods = useSelector(budgetBuilderSelectors.periodRows);
	const sponsoredCostsByPeriodWithSubawards = useSelector(budgetBuilderSelectors.sponsoredCostsByPeriod);
	const categories = useSelector(tenantSelectors.proposalCategories);

	const sponsoredCostsByPeriod = useMemo(() => {
		let sponsoredCostsByPeriod = {};
		for (let period of periods) {
			const periodNumber = period.periodNumber;
			let sponsoredCostsForPeriod = sponsoredCostsByPeriodWithSubawards?.[periodNumber] || getDefaultLineItems(
				categories,
				period?.rateForPeriod
			);
			if (isNonEmptyArray(sponsoredCostsForPeriod)) {
				sponsoredCostsForPeriod = sponsoredCostsForPeriod.filter(sponsoredCost => sponsoredCost?.value !== "Subawards");
			}
			sponsoredCostsByPeriod[periodNumber] = sponsoredCostsForPeriod;
		}

		return sponsoredCostsByPeriod;
	}, [ categories, periods, sponsoredCostsByPeriodWithSubawards ]);

	const sponsoredCostsDataByHash = useMemo(
		() => convertByPeriodToByItem(sponsoredCostsByPeriod, periods.length),
		[ periods.length, sponsoredCostsByPeriod ],
	);

	const categorySortByHash = useMemo(
		() => convertToLookupTable(categories, "hash", "sort"),
		[ categories ]
	);

	const sortedEntries = useMemo(
		() => Object.entries(sponsoredCostsDataByHash).sort((firstHashAndCostsPair, secondHashAndCostsPair) =>
			categorySortByHash[firstHashAndCostsPair[0]] - categorySortByHash[secondHashAndCostsPair[0]],
		),
		[ categorySortByHash, sponsoredCostsDataByHash ]
	);

	return (
		<>
			{sortedEntries.map(([ i, datum ]) => (
				<OverviewSponsoredCostsRow
					key={i}
					hash={i}
					categoryData={datum}
					periods={periods}
				/>
			))}
		</>
	);
};
